import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import '@ant-design/v5-patch-for-react-19';
import './wdyr'; // <--- first import
import uroTheme from './utils/theme/themeConfig';

// Prerendered pages arrive with markup in #root; hydrate it instead of
// throwing it away so the first paint is the one crawlers already saw.
const container = document.getElementById('root');
const app = (
  <React.StrictMode>
  <App />
  </React.StrictMode>
);
//inject theme into index.css body
document.body.style.backgroundColor = uroTheme.colors.background;
if (container.hasChildNodes()) ReactDOM.hydrateRoot(container, app, { onRecoverableError: () => {} });
else ReactDOM.createRoot(container).render(app);
